import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-0 truncate"
}
const _hoisted_2 = {
  key: 0,
  class: "truncate block"
}
const _hoisted_3 = {
  key: 0,
  class: "truncate block"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "mb-0 text-end"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center justify-content-start"
}
const _hoisted_7 = {
  key: 1,
  class: "mb-0 text-end"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 7,
  class: "mb-0 text-end"
}
const _hoisted_10 = {
  key: 0,
  class: "text-end mb-0 truncate"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "mb-0 text-end truncate"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "break-word"
}

import { computed } from "vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import QuantityInputCustom from "@/components/forms-elements/QuantityInputCustom.vue";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import { normalizeTableRow } from "./composables/normalizeTableRow";
import {
  isFooterRow,
  usePhieuXuatKhoTableCellApi,
} from "./composables/usePhieuXuatKhoTableCellApi";
import type { PhieuXuatKhoTableColumnId } from "./composables/usePhieuXuatKhoTableColumns";
import PhieuXuatKhoVatTuFooterCell from "./PhieuXuatKhoVatTuFooterCell.vue";
import type { PhieuXuatKhoTableRow } from "./types";


export default /*#__PURE__*/_defineComponent({
  __name: 'PhieuXuatKhoVatTuCell',
  props: {
    columnId: {},
    row: {},
    rowIndex: {}
  },
  setup(__props: any) {

const props = __props;

const api = usePhieuXuatKhoTableCellApi();
const { ButtonsType, ButtonTypeColors } = useButtonCustom();
const isSummaryMode = api.isSummaryMode;
const normalized = computed(() => normalizeTableRow(props.row));

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_unref(isFooterRow)(_ctx.row))
    ? (_openBlock(), _createBlock(PhieuXuatKhoVatTuFooterCell, {
        key: 0,
        "column-id": _ctx.columnId,
        row: _ctx.row
      }, null, 8, ["column-id", "row"]))
    : (_ctx.columnId === 'stt')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString(_ctx.rowIndex + 1), 1)
        ], 64))
      : (_ctx.columnId === 'ten_vat_tu')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (!_unref(isSummaryMode))
              ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(normalized.value.tenVatTu), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(normalized.value.tenVatTu), 1)
                ], 64))
          ], 64))
        : (_ctx.columnId === 'ma_vat_tu')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              (!_unref(isSummaryMode))
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(normalized.value.maVatTu), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(normalized.value.maVatTu || "-"), 1)
                  ], 64))
            ], 64))
          : (_ctx.columnId === 'don_vi_tinh')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (!_unref(isSummaryMode))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(normalized.value.donViTinh ? normalized.value.donViTinh : "-"), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(normalized.value.donViTinh || ""), 1)
                    ], 64))
              ], 64))
            : (_ctx.columnId === 'ton_kho')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (_unref(isSummaryMode))
                    ? (_openBlock(), _createElementBlock("strong", _hoisted_4, _toDisplayString(_unref(api).formatQuantity(normalized.value.tonKho ?? 0)), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(api).formatQuantity(
          _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)
            ?.so_luong_trong_kho_ban_dau ?? 0
        )), 1))
                ], 64))
              : (_ctx.columnId === 'so_luong_xuat')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                    (!_unref(isSummaryMode) && _unref(api).canEditQuantity(normalized.value.idVatTu!))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(QuantityInputCustom, {
                            modelValue: _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.so_luong_se_lay,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.so_luong_se_lay) = $event)),
                            "class-str": "w-100",
                            min: _unref(api).getQuantityMin(normalized.value.idVatTu!),
                            onBlur: _cache[1] || (_cache[1] = () => _unref(api).onQuantityBlur(normalized.value.idVatTu!)),
                            onChange: _cache[2] || (_cache[2] = (value) => _unref(api).onQuantityChange(normalized.value.idVatTu!, value)),
                            onFocus: _cache[3] || (_cache[3] = ($event: any) => (_unref(api).onQuantityFocus(normalized.value.idVatTu!, $event)))
                          }, null, 8, ["modelValue", "min"])
                        ]))
                      : (!_unref(isSummaryMode))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(api).formatQuantity(
          _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)?.so_luong_se_lay ??
            0
        )), 1))
                        : (_openBlock(), _createElementBlock("strong", _hoisted_8, _toDisplayString(_unref(api).formatQuantity(normalized.value.soLuongXuat ?? 0)), 1))
                  ], 64))
                : (_ctx.columnId === 'sl_dinh_muc')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(api).calcRemainingNeed(normalized.value.idVatTu!)), 1))
                  : (_ctx.columnId === 'don_gia')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                        (!_unref(isSummaryMode))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(api).formatUnitPrice(_unref(api).getDonGia(normalized.value.idVatTu!))), 1))
                          : (_openBlock(), _createElementBlock("strong", _hoisted_11, _toDisplayString(_unref(api).formatUnitPrice(normalized.value.donGia!)), 1))
                      ], 64))
                    : (_ctx.columnId === 'thanh_tien')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                          (!_unref(isSummaryMode))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_unref(api).thanhTienCalc(normalized.value.idVatTu!)), 1))
                            : (_openBlock(), _createElementBlock("strong", _hoisted_13, _toDisplayString(_unref(api).formatAmount(
          _unref(api).calcThanhTien(normalized.value.donGia!, normalized.value.soLuongXuat!)
        )), 1))
                        ], 64))
                      : (_ctx.columnId === 'ghi_chu')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                            (!_unref(isSummaryMode) && !_unref(api).readonly && _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!))
                              ? (_openBlock(), _createBlock(_component_el_input, {
                                  key: 0,
                                  modelValue: _unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.ghi_chu,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)!.ghi_chu) = $event)),
                                  rows: "1",
                                  type: "textarea",
                                  onInput: _unref(api).emitQuantityChange
                                }, null, 8, ["modelValue", "onInput"]))
                              : (!_unref(isSummaryMode))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_unref(api).getQuantityRowByVatTuId(normalized.value.idVatTu!)?.ghi_chu ?? "-"), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(normalized.value.ghiChu || ""), 1))
                          ], 64))
                        : (_ctx.columnId === 'delete')
                          ? (_openBlock(), _createBlock(ButtonCustom, {
                              key: 11,
                              "button-type": _unref(ButtonsType).TRASH,
                              "color-type": _unref(ButtonTypeColors).DANGER,
                              "tooltip-message": "Xoá vật tư",
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(api).emitDeleteItem(normalized.value.idVatTu!)))
                            }, null, 8, ["button-type", "color-type"]))
                          : _createCommentVNode("", true)
}
}

})